import React from 'react';
import { Link } from 'react-router-dom';
import { trackLandingCtaClick } from '../utils/analytics';
import './CapabilitiesSection.css';

/** Same public Reader order as header: News · Desk · Web · Feed · Stringers */
const CAPABILITIES = [
  {
    title: 'News',
    description: 'AI-assembled section editions',
    path: '/news',
    label: 'news',
  },
  {
    title: 'Desk',
    description: 'Live board by beat as stories break',
    path: '/desk',
    label: 'desk',
  },
  {
    title: 'Web',
    description: 'Entity graph: people, places, orgs',
    path: '/web',
    label: 'web',
  },
  {
    title: 'Feed',
    description: 'Semantic search across the archive',
    path: '/feed',
    label: 'feed',
  },
  {
    title: 'Stringers',
    description: 'Writer magazine and NewsAgent Shorts',
    path: '/stringers',
    label: 'stringers',
  },
];

const CapabilitiesSection = () => {
  return (
    <section className="capabilities-section" aria-label="Platform capabilities">
      <div className="container">
        <div className="capabilities-grid">
          {CAPABILITIES.map(({ title, description, path, label }) => (
            <Link
              key={title}
              to={path}
              className="capability-card"
              onClick={() => trackLandingCtaClick(label)}
            >
              <h3>{title}</h3>
              <p>{description}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CapabilitiesSection;
